var map = {
	"./BarCode.svg": 65045,
	"./EllipseIcon.svg": 50604,
	"./H.svg": 60277,
	"./HLine.svg": 78255,
	"./ImageIcon.svg": 21589,
	"./QrCode.svg": 77157,
	"./RectIcon.svg": 29778,
	"./TableIcon.svg": 15450,
	"./TextIcon.svg": 39881,
	"./TextLong.svg": 84104,
	"./VLine.svg": 641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53072;